import React, { useMemo } from 'react';

import { useConfiguredDevicesContext } from 'client/app/state/ConfiguredDevicesProvider/ConfiguredDevicesProvider';
import { ParameterEditorBaseProps } from 'common/ui/components/ParameterEditorBaseProps';
import Dropdown from 'common/ui/filaments/Dropdown';

type Props = {
  value: string;
  onChange: (value?: string) => void;
} & ParameterEditorBaseProps<string>;

export const TipTypeDropdownEditor = function (props: Props) {
  const { value } = props;
  const { activeMainConfiguredDeviceConfig } = useConfiguredDevicesContext();
  const supportedTipTypes = activeMainConfiguredDeviceConfig?.supportedTipTypes;

  const options = useMemo(() => {
    return (
      supportedTipTypes?.map(tt => ({ value: tt.name, label: tt.shortDescription })) ?? []
    );
  }, [supportedTipTypes]);

  const labelForValue = useMemo(() => {
    return supportedTipTypes?.find(tt => tt.name === value)?.shortDescription ?? '';
  }, [supportedTipTypes, value]);

  return (
    <Dropdown
      placeholder={props.placeholder}
      valueLabel={labelForValue}
      options={options}
      onChange={props.onChange}
      isDisabled={props.isDisabled}
      isRequired={props.isRequired}
    />
  );
};
